module.exports = __webpack_public_path__ + "img/Headband-Wigs-with-Highligh.0019570e.jpg";